import React, { Component, Fragment } from 'react'
import Grid from '../../../Utils/Grid/index';
import { TableHeaderColumn } from 'react-bootstrap-table';
import {standardActions} from "../../../Utils/Grid/StandardActions";
import ToolbarRecibosCaja from '../../../Utils/Toolbar/ToolbarRecibosCaja';
import ImageVer from '../../../../../../assets/img/icons/Ver.png';

//Extras
import {RenderMoneda, RenderDateTime} from "../../../Utils/renderField/renderTableField";


export default class RecibosCaja extends Component {
    componentWillMount() {
        const { listar, page, permisos } = this.props;
        listar(page);
    }
    render() {
        const { data, loader, listar: onPageChange, onSortChange, page, setOpenModal,
            permisos
        } = this.props;

        return (
            <Fragment>
                <div className="py-md-3 px-md-3 p-0" style={{border:"1px solid #E8E8E8", }}>
                    <ToolbarRecibosCaja
                        // idVendedor={this.props.id_user}
                        permisos={permisos}
                        fecha_I={this.props.fecha_I}
                        fecha_F={this.props.fecha_F}
                        changeCliente={this.props.changeCliente}
                        changeRangeDate={this.props.changeRangeDate}
                        changeCobrador={this.props.changeCobrador}
                        estado={this.props.estado_recibos}
                        estadoChange={this.props.estadoRecibosChange}
                        buscar={this.props.searchChangeRecibosCaja}
                        buscador={this.props.search_recibos_caja}
                        placeholder={"Buscar por: No. Recibo"}
                    />
                </div>

           <Grid
                hover
                striped
                page={page}
                data={data}
                loading={loader}
                onPageChange={onPageChange}
                onSortChange={onSortChange}
            >
                <TableHeaderColumn
                    dataField="id"
                    dataAlign="center"
                    isKey
                    dataSort
                    width="3%"
                    dataFormat={(cell, row) => {
                        return standardActions({
                            vermodal: this.props.abrirModalPago,
                        })(cell, row);
                    }}
                >
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="fecha"
                    dataSort
                    dataFormat = {
                        (cell, row) => (
                            <RenderDateTime fecha={cell} />
                        )
                    }
                >
                    FECHA
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="no_recibo_caja"
                    dataSort
                    dataFormat = {
                        (cell, row) => (
                            cell ? cell.toUpperCase() : ''
                        )
                    }
                >
                    No. RECIBO CAJA
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="cobrador_nombre"
                    dataSort
                    dataFormat = {
                        (cell, row) => {
                            if (cell){
                                return <p>{cell.toUpperCase()}</p>
                            }
                        }
                    }
                >
                    COBRADOR
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="cliente__nombre"
                    dataSort
                    dataFormat = {
                        (cell, row) => {
                            if (cell){
                                return <p>{cell.toUpperCase()}</p>
                            }
                        }
                    }
                >
                    CLIENTE
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="monto"
                    dataSort
                    dataFormat = {
                        (cell, row) => (
                            <RenderMoneda monto={row.monto ? cell : 0} simbolo={'Q. '}/>
                        )
                    }
                >
                    MONTO
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="monto"
                    dataSort
                    dataFormat = {
                        (cell, row) => {
                            if (!row.estado) return 'ANULADO'
                            else if (row.afectado_es_flotante && row.afectado_tipo_flotante) return 'PENDIENTE VALIDACIÓN'
                            else if (!row.afectado_es_flotante && (row.count_asingaciones_efectivo > 0 || row.count_asingaciones > 0)) return 'ASIGNADO'
                        }
                    }
                >
                    ESTADO
                </TableHeaderColumn>
            </Grid>

            </Fragment>
        );
    }
}